<script setup lang="ts">
import { useGlobalModal } from "@/stores/globalModal";
import { useGlobalUser } from "@/stores/globalUser";
import { computed } from "vue";

defineProps<{
  tips?: "left";
}>();

const modalStore = useGlobalModal();
const userStore = useGlobalUser();

const preferredModel = computed(() => userStore.user.preferredModel);
</script>
<template>
  <button
    class="btn btn-xs btn-outline rounded relative whitespace-nowrap"
    @click="modalStore.showSelectModelModal = true"
  >
    <template v-if="tips === 'left'"> 模型:</template>

    {{ $t(`chat.model.${preferredModel}.name`) }}

    <div
      v-if="tips !== 'left'"
      class="absolute -top-6 left-1/2 -translate-x-1/2 bg-neutral text-[10px] text-neutral-content/60 px-2 py-1 rounded-md shadow-sm whitespace-nowrap before:content-[''] before:absolute before:top-full before:left-1/2 before:-translate-x-1/2 before:border-4 before:border-transparent before:border-t-neutral"
    >
      模型
    </div>
  </button>
</template>
